import { ADDRESSES_CHANGE_ACTIVE_ADDRESS } from './constants'

// eslint-disable-next-line
export function addressesChangeActiveAddress(module, id, block, customData) {
    return {
        type: ADDRESSES_CHANGE_ACTIVE_ADDRESS,
        data: {
            module,
            id,
            blockKey: block,
            customData,
        },
    }
}
